import React from 'react';

var OpenHours = React.createClass({

  render: function(){
    if (this.props.hours) {
      var regex = new RegExp('^' + this.props.weekday + ':', 'i');

      var hrs = this.props.hours.filter(function(wk){
        return regex.test(wk);
      }).map(function(hr){
        var h = hr.replace(regex, 'Open');
        return <span key={1}>{h}</span>;
      });
      return <p className="open-hours"><i className="fa fa-clock-o"></i>{hrs}</p>;
    } else {
      return null;
    } 
  }
});

module.exports = OpenHours;



// WEBPACK FOOTER //
// ./components/open-hours.js